module.exports = __webpack_public_path__ + "img/infoIcon.390b5d32.svg";